export const BOOKING_LOCATION = 'booking-location';
